/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGlobalShare = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M5.225 10.2a7.64 7.64 0 0 0 0 3.6h3.543a13 13 0 0 1-.157-1.814q.018-.903.157-1.786zm.481-1.385H9.06a13.4 13.4 0 0 1 1.994-4.268 7.63 7.63 0 0 0-5.347 4.268m6.92-4.058a12 12 0 0 0-2.128 4.058h4.256a12 12 0 0 0-2.128-4.058m2.455 5.443h-4.91a12 12 0 0 0-.176 1.8q.021.911.176 1.8h4.91q.155-.889.176-1.8a12 12 0 0 0-.176-1.8m1.403 3.6a13 13 0 0 0 .157-1.814 13 13 0 0 0-.157-1.786h3.543a7.64 7.64 0 0 1 0 3.6zm-1.73 1.385h-4.256c.44 1.47 1.16 2.848 2.128 4.058a12 12 0 0 0 2.128-4.058m-3.701 4.268a13.4 13.4 0 0 1-1.994-4.268H5.706a7.63 7.63 0 0 0 5.347 4.268m3.146 0a13.4 13.4 0 0 0 1.994-4.268h3.352a7.63 7.63 0 0 1-5.346 4.268m5.347-10.638h-3.353a13.4 13.4 0 0 0-1.994-4.268 7.63 7.63 0 0 1 5.347 4.268M3.626 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0" clipRule="evenodd" /></svg>;
export default SvgGlobalShare;